import { useRouter } from 'next/router';
import TopIssuersContextProvider
  from '@/creditflowresearch/application/TopCompanies/topCompaniesContexts/TopIssuersContext';
import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import TopCompanyCommonContextProvider, {
  useTopCompanyCommonContext,
} from '@/creditflowresearch/application/TopCompanies/topCompaniesCommon/TopCompaniesCommonContext';
import TopRatingAgencyContextProvider
  from '@/creditflowresearch/application/TopCompanies/topCompaniesContexts/TopRatingAgenciesContext';
import TopUnderwritersContextProvider
  from '@/creditflowresearch/application/TopCompanies/topCompaniesContexts/TopUnderwritersContext';
import {
  ISSUER_NAME,
  PARENT_NAME,
  TOP_COMPANIES_CONFIG,
} from '@/creditflowresearch/ui/components/TopCompanies/constants';
import TopCompaniesCommon from '@/creditflowresearch/ui/components/TopCompanies/TopCompaniesCommon';

const TopCompanies = ({ className }: { className?: string }) => {
  const { query: { companyViewId } } = useRouter();
  const commonData = useTopCompanyCommonContext();
  const { activeTab } = commonData;
  const currentActiveTab = companyViewId && activeTab === ISSUER_NAME ? PARENT_NAME : activeTab;
  const { component: Component, title } = TOP_COMPANIES_CONFIG[currentActiveTab];

  return (
    <TopCompaniesCommon component={ <Component /> } commonData={ commonData } title={ title } className={ className } />
  );
};

export default ({ className }: { className?: string }) => {
  const { topParents } = useParentPageContext();

  return (
    <TopCompanyCommonContextProvider topParents={ topParents }>
      <TopIssuersContextProvider topParents={ topParents }>
        <TopRatingAgencyContextProvider>
          <TopUnderwritersContextProvider>
            <TopCompanies className={ className } />
          </TopUnderwritersContextProvider>
        </TopRatingAgencyContextProvider>
      </TopIssuersContextProvider>
    </TopCompanyCommonContextProvider>
  );
};
